import {createReducer, on} from "@ngrx/store";
import * as DefensesActions from './defenses.actions';
import {Defense} from "../../models/Defense";
export const DefensesFeatureKey = 'defenses';
export const DefensesInitialState: Defense[] = [];
export const DefensesReducer = createReducer<Defense[]>(
  DefensesInitialState,
  on(DefensesActions.update, (_state, { defenses }) => defenses),
);
